// Carleton College's majors (#2743). Read on 2026-10-01 from the official
// 2026-2027 Academic Catalog's Academic Requirements page, which lists "the
// following 33 majors" and says students receive a Bachelor of Arts degree;
// Carleton has no separate schools, so the list is one group. The catalog
// writes no abbreviation; "B.A." stands for the Bachelor of Arts it names.
// Left out: the 39 minors and self-designed special majors (proposed to the
// Academic Standing Committee, not a listed major). The catalog's curly
// apostrophe in "Women's" is typed straight. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "carleton-college",
    "read": "2026-10-01",
    "intro": "Every major in Carleton's official 2026-2027 Academic Catalog, each leading to the Bachelor of Arts. Minors and special (self-designed) majors are left out.",
    "groups": [
        {
            "name": "Carleton College",
            "source": {
                "label": "Carleton 2026-2027 Academic Catalog, Academic Requirements",
                "url": "https://www.carleton.edu/catalog/2026/requirements/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Women's & Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science and International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology/Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Theater Arts",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
